<div class="card detail">
  <div class="card-body">
    <div class="title text-left">
      <h3 class="card-title">{{ 'Widgets' | translate }}</h3>
      <h6 class="card-subtitle mb-4 text-muted">{{ 'Select one or many tools to keep in the default command centre' |
        translate }}</h6>
    </div>
    <div class="widget-container">
      <ul class="list-group">
        <li class="list-group-item">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="widget1">
            <label class="form-check-label" for="widget1">{{ 'defect quantity by severity' | translate }}</label>
          </div>
          <app-widget-one [data]="[]"></app-widget-one>
        </li>
        <li class="list-group-item">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="widget2">
            <label class="form-check-label" for="widget2">{{ 'Project Planner' | translate }}</label>
          </div>
          <app-widget-two></app-widget-two>
        </li>
        <li class="list-group-item">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="widget3">
            <label class="form-check-label" for="widget3">{{ 'Project Planner' | translate }}</label>
          </div>
          <app-widget-three></app-widget-three>
        </li>
      </ul>
    </div>
  </div>
</div>